import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routers from "./routes/Routers";
import "../src/assets/css/global.css";
import "../src/assets/css/admin.css";
import "../src/assets/css/admin.responsive.css";
import "../src/assets/css/newadmin.css";
import "../src/assets/css/globanew.css";
import "../src/assets/css/global.responsive.css";
import { MeshProvider } from "@meshsdk/react";
import "@meshsdk/react/styles.css";
import { createAppKit } from "@reown/appkit/react";
import { Ethers5Adapter } from "@reown/appkit-adapter-ethers5";
import { mainnet, polygon, solana } from "@reown/appkit/networks";
import { SolanaAdapter } from "@reown/appkit-adapter-solana/react";

// 1. Get projectId
const projectId = "2153db670a2a45ecb63588df6db52c07";
const solanaWeb3JsAdapter = new SolanaAdapter();
// 2. Create a metadata object - optional
const metadata = {
  name: "My Website",
  description: "My Website description",
  url: "https://mywebsite.com", // origin must match your domain & subdomain
  icons: ["https://avatars.mywebsite.com/"],
};

// 3. Create the AppKit instance
createAppKit({
  adapters: [new Ethers5Adapter(),solanaWeb3JsAdapter],
  metadata: metadata,
  networks: [mainnet, polygon,solana],
  projectId,
  features: {
    analytics: true, 
  },

  allWallets: "ONLY_MOBILE",
});

function App() {
  
  return (
    <MeshProvider>
      <div className="App">
        <ToastContainer />
              <Routers />
            </div>
          </MeshProvider>
       
  );
}

export default App;
